<template>
<div>
  <!--blog Section start-->
  <div class="page-margin">
    <!--breadcrumb start-->
    <div class="breadcrumb-bg">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-6 col-text-center d-align-center">
            <h2 class="title">
              <span> FAQ </span> Auto Repair Financing
            </h2>
          </div>
          <div class="col-md-6 col-sm-6 col-text-center">
            <nav aria-label="breadcrumb" class="blog-bradcrumb ">
              <ol class="breadcrumb bg-transparent mb-0">
                <li class="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li class="breadcrumb-item active">
                  <a href="#">FAQ</a>
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!--breadcrumb end -->

    <!-- sign in -->
    <section>
      <!--faq in -->
      <div class="faq">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div id="accordion" role="tablist">

                <div class="card border-theme mb-3 radius-0">
                  <div v-b-toggle.collapseOne class="card-header" role="tab">
                    <a class="">I created an account, how long does it take until the repair begins?<i class="fa fa-angle-down float-right" /></a>
                  </div>
                  <b-collapse id="collapseOne" role="tabpanel" visible accordion="my-accordion" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                      We can process your application within 10 minutes, all you need to do is follow the instructions on your dashboard.
                    </div>
                  </b-collapse>
                </div>

                <div class="card border-theme mb-3 radius-0">
                  <div v-b-toggle.collapseTwo class="card-header" role="tab">
                    <a class=""> What information do I need to provide for the car repair financing?<i class="fa fa-angle-down float-right" /></a>
                  </div>
                  <b-collapse id="collapseTwo" class="collapse show" accordion="my-accordion" role="tabpanel" aria-labelledby="headingTwo" data-parent="#accordion">
                    <div class="card-body">
                      No personal information needed, we only need details about the vehicle that you upload in our secured platform the insurance, driver's license and a copy of a void cheque.
                    </div>
                  </b-collapse>
                </div>

                <div class="card border-theme mb-3 radius-0">
                  <div v-b-toggle.collapseThree class="card-header">
                    <a class=""> Can I apply for a repair loan at an auto body shop?<i class="fa fa-angle-down float-right" /></a>
                  </div>
                  <b-collapse id="collapseThree" class="collapse show" accordion="my-accordion" aria-labelledby="headingThree" data-parent="#accordion">
                    <div class="card-body">
                      Yes, but the repair needs to be as a result of a collision or rust repair.
                    </div>
                  </b-collapse>
                </div>

                <div class="card border-theme mb-3 radius-0">
                  <div v-b-toggle.collapseFour class="card-header">
                    <a class="">Would I have to pay upfront costs?<i class="fa fa-angle-down float-right" /></a>
                  </div>
                  <b-collapse id="collapseFour" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingFour" data-parent="#accordion">
                    <div class="card-body">
                      Only in case the loan amount doesn't cover the total cost of the repair. Fees involved to process the loan are already included in the total loan amount.
                    </div>
                  </b-collapse>
                </div>

                <div class="card border-theme mb-3 radius-0">
                  <div v-b-toggle.collapseFive class="card-header">
                    <a class="">How are my loan payments processed?<i class="fa fa-angle-down float-right" /></a>
                  </div>
                  <b-collapse id="collapseFive" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingFive" data-parent="#accordion">
                    <div class="card-body">
                      The payments are processed through your bank account's pre-authorized payments.
                    </div>
                  </b-collapse>
                </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div v-b-toggle.collapseSix class="card-header">
                      <a class="">Can I pay off the car repair loan anytime?<i class="fa fa-angle-down float-right" /></a>
                    </div>
                    <b-collapse id="collapseSix" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingSix" data-parent="#accordion">
                      <div class="card-body">
                        Yes, our car repair loans are open so you can pay it off without any fees. If you need to pay it off we can withdraw the balance electronically from your bank account.
                      </div>
                    </b-collapse>
                  </div>

                  <div class="card border-theme mb-3 radius-0">
                    <div v-b-toggle.collapseSeven class="card-header">
                      <a class="">My car repair $5000 can I apply for $5000?<i class="fa fa-angle-down float-right" /></a>
                    </div>
                    <b-collapse id="collapseSeven" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingSeven" data-parent="#accordion">
                      <div class="card-body">
                        Yes, keep in mind the maximum amount depends on the vehicle's value as our car repair loans are secured by the vehicle being repaired.
                      </div>
                    </b-collapse>
                  </div>

                    <div class="card border-theme mb-3 radius-0">
                      <div v-b-toggle.collapseEight class="card-header">
                        <a class="">Can I buy parts as part of the repair loan?<i class="fa fa-angle-down float-right" /></a>
                      </div>
                      <b-collapse id="collapseEight" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingEight" data-parent="#accordion">
                        <div class="card-body">
                          Our repair loans require that all parts purchased through us will be installed by us meaning parts alone that aren't being installed don't qualify for a loan.
                        </div>
                      </b-collapse>
                    </div>

                    <div class="card border-theme mb-3 radius-0">
                      <div v-b-toggle.collapseNine class="card-header">
                        <a class="">How do I pay for the financed car repair?<i class="fa fa-angle-down float-right" /></a>
                      </div>
                      <b-collapse id="collapseNine" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingNine" data-parent="#accordion">
                        <div class="card-body">
                          Using a PAD agreement the payments will be automatically withdrawn from your bank account.<br />
                          If you need to make a payment using a Visa Debit, you can call us or contact us via our live chat.
                        </div>
                      </b-collapse>
                    </div>

                      <div class="card border-theme mb-3 radius-0">
                        <div v-b-toggle.collapseTen class="card-header">
                          <a class="">What is the maximum term of the loan?<i class="fa fa-angle-down float-right" /></a>
                        </div>
                        <b-collapse id="collapseTen" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingTen" data-parent="#accordion">
                          <div class="card-body">
                            It is 24 months, you can customize your payment plan to 18 months and 12 months for shorter periods.
                          </div>
                        </b-collapse>
                      </div>

                      <div class="card border-theme mb-3 radius-0">
                        <div v-b-toggle.collapseEleven class="card-header">
                          <a class="">What are the fees and rates for the car repair loan?<i class="fa fa-angle-down float-right" /></a>
                        </div>
                        <b-collapse id="collapseEleven" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingEleven" data-parent="#accordion">
                          <div class="card-body">
                            Our loans include the following fees: administration fee ($39), lien registration ($29), lien search($19). After adding the fees to
                            the beginning balance the loan is then calculated at an annual interest rate of 14.9% + account managment fee with APR ranging from 11.9%-27.9%.
                          </div>
                        </b-collapse>
                      </div>
                        <div class="card border-theme mb-3 radius-0">
                          <div v-b-toggle.collapseTwelve class="card-header">
                            <a class="">Does ezFix'd have a privacy policy?<i class="fa fa-angle-down float-right" /></a>
                          </div>
                          <b-collapse id="collapseTwelve" role="tablist" accordion="my-accordion" class="collapse show" aria-labelledby="headingTwelve" data-parent="#accordion">
                            <div class="card-body">
                              Yes, you can access our privacy policy <a href="https://ezfixd.com/privacy-policy">here</a>
                            </div>
                          </b-collapse>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- faq up -->
    </section>
    <!-- sign up -->
    <!--blog Section end-->
  </div>
  <!--Footer Section start-->
  <js />
  <!--Footer Section End-->
</div>
</template>
<script>
export default {
  name: 'Faq',
}
</script>



// WEBPACK FOOTER //
// src/pages/faq.vue